import React from 'react'
import { Field } from 'redux-form'
import Formatters from 'utils/Formatters'

import InputFieldComponent from '../component/InputFieldComponent'

const { formatPhone } = Formatters

const PhoneNumberField = ({ placeholder }) => {
  return <Field name="phoneNumber" format={value => formatPhone(value, "-")} placeholder={placeholder} component={InputFieldComponent} />
}

export default PhoneNumberField
